module.exports = __webpack_public_path__ + "static/media/datavase_logo_icon_grey.32886d71.png";